import { Link } from "react-router-dom";
import { ArrowUpRight, Radio, Sparkles } from "lucide-react";

export default function CTA({ index = "09" }: { index?: string }) {
  return (
    <section data-testid="cta-section" className="relative py-24 md:py-32">
      <div className="container-edx">
        <div className="cta-command">
          <div className="cta-command-grid" />
          <div className="relative z-10">
            <div className="section-index">EDX.{index}</div>
            <h2>
              LET&apos;S BUILD WHAT<br />
              <span>COMES NEXT.</span>
            </h2>
            <p>
              Start with a focused 30-minute consultation. We will map the problem,
              identify the right technical path, and define a practical next move.
            </p>
          </div>
          <div className="relative z-10 flex flex-col gap-3 md:items-end">
            <Link to="/consultation" data-testid="cta-book" className="btn btn-primary">
              Book free consultation <ArrowUpRight size={16} />
            </Link>
            <Link to="/mission-control" data-testid="cta-contact" className="btn btn-ghost">
              <Sparkles size={15} /> Open mission control
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
